import { rest } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import {
  zServFunc,
  ZServFunc,
} from "../../../../../businessServices/ZServFunc";

const urlFuncs = (objectId: ZUid, serviceId: ZUid): string =>
  apiObjUrl(`/business-services/${objectId}/services/${serviceId}/functions`);

export const loadServFunctions = async (
  objectId: ZUid,
  serviceId: ZUid,
): Promise<ZServFunc[]> => {
  const resp = await rest.get(urlFuncs(objectId, serviceId));
  return zServFunc.array().parse(resp.data);
};

export const saveServFunctions = async (
  objectId: ZUid,
  serviceId: ZUid,
  funcs: ZServFunc[],
) => {
  await rest.post(urlFuncs(objectId, serviceId), funcs);
};
